import i18next from 'i18next';
import { memoize } from 'lodash';
import type { I18nMap } from './types.ts';

export const Languages = (featureNewLanguage = false) => {
  if (featureNewLanguage) {
    return {
      EN: { abrev: 'en', label: 'English (GB)', testId: 'button-language-english' },
      'EN-US': { abrev: 'en-us', label: 'English (US)', testId: 'button-language-us-english' },
      'PT-BR': { abrev: 'pt-BR', label: 'Português (BR)', testId: 'button-language-portuguese' },
      ES: { abrev: 'es', label: 'Español (España)', testId: 'button-language-espanol' },
      'ES-AR': { abrev: 'es-ar', label: 'Español (AR)', testId: 'button-language-ar-espanol' },
      'PL-PL': { abrev: 'pl-PL', label: 'Polskie (PL)', testId: 'button-language-polskie' },
      'DE-DE': { abrev: 'de-DE', label: 'Deutsch (DE)', testId: 'button-language-deutsch' },
      'FR-FR': { abrev: 'fr-FR', label: 'Français (FR)', testId: 'button-language-francois' },
      'HU-HU': { abrev: 'hu-HU', label: 'Magyar (HU)', testId: 'button-language-hungarian' },
      IT: { abrev: 'it', label: 'Italian (IT)', testId: 'button-language-italian' },
      RU: { abrev: 'ru', label: 'Russian (RU)', testId: 'button-language-russian' }
    };
  }

  return {
    EN: { abrev: 'en', label: 'English (GB)', testId: 'button-language-english' },
    'EN-US': { abrev: 'en-us', label: 'English (US)', testId: 'button-language-us-english' },
    'PT-BR': { abrev: 'pt-BR', label: 'Português (BR)', testId: 'button-language-portuguese' },
    ES: { abrev: 'es', label: 'Español (España)', testId: 'button-language-espanol' },
    'ES-AR': { abrev: 'es-ar', label: 'Español (AR)', testId: 'button-language-ar-espanol' },
    'PL-PL': { abrev: 'pl-PL', label: 'Polskie (PL)', testId: 'button-language-polskie' },
    'DE-DE': { abrev: 'de-DE', label: 'Deutsch (DE)', testId: 'button-language-deutsch' },
    'FR-FR': { abrev: 'fr-FR', label: 'Français (FR)', testId: 'button-language-francois' },
    RU: { abrev: 'ru', label: 'Russian (RU)', testId: 'button-language-russian' }
  };
};

export function getLanguagesAble() {
  const oldLanguages = {
    pt: 'pt-BR',
    'pt-BR': 'pt-BR',
    'pt-PT': 'pt-PT',
    es: 'es',
    de: 'de-DE',
    'de-DE': 'de-DE',
    pl: 'pl-PL',
    'pl-PL': 'pl-PL',
    fr: 'fr-FR',
    'fr-FR': 'fr-FR',
    'en-US': 'en-us',
    'en-GB': 'en',
    'es-ar': 'es-ar',
    'hu-hu': 'hu-HU',
    'el-GR': 'el',
    el: 'el',
    ru: 'ru'
  };

  const newLanguages = { ...oldLanguages, it: 'it' };
  const arrayLanguages = process.env.VITE_ENV === 'production' ? oldLanguages : newLanguages;
  return arrayLanguages;
}

const getCurrentLanguageFromStorage = (): string => {
  const currentLanguage = localStorage.getItem('currentLanguage') ?? i18next.language;
  const arrayLanguages = getLanguagesAble();
  return currentLanguage?.toLocaleLowerCase() ?? arrayLanguages[navigator.language as keyof typeof arrayLanguages] ?? 'en';
};

export const getCurrentLanguage = memoize(getCurrentLanguageFromStorage);

export const getNameByCurrentLanguage = (name: I18nMap | undefined): string => {
  if (!name) return '';

  const currentLanguage = getCurrentLanguage().toLowerCase();
  let fallback = name.localized_strings ? name.localized_strings[Object.keys(name.localized_strings)[0]] : '';

  const nameReduce = name.localized_strings
    ? Object.entries(name.localized_strings).reduce((arr, [key, value]) => {
        if (key.toLowerCase() === currentLanguage) return value;

        if (key.toLowerCase().split('-')[0] === currentLanguage.split('-')[0]) {
          fallback = value;
        }
        return arr;
      }, '')
    : '';

  return nameReduce || fallback;
};

export const getStringOrLocalizedString = (value?: string | I18nMap): string => {
  if (!value) return '';

  if (typeof value === 'string') return value;

  return getNameByCurrentLanguage(value);
};
